module.exports = __webpack_public_path__ + "img/motor_no50.052e5a65.jpg";